import { render, staticRenderFns } from "./CreateSimulationFromExtensionModal.vue?vue&type=template&id=13ce99fd&scoped=true&"
import script from "./CreateSimulationFromExtensionModal.vue?vue&type=script&lang=js&"
export * from "./CreateSimulationFromExtensionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSimulationFromExtensionModal.vue?vue&type=style&index=0&id=13ce99fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce99fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
